import { combineReducers } from 'redux';

import { reducer as ads } from './ads/reducer';
import bankId from '../components/bank-id/state/bank-id/reducer';
import auth from './auth/reducer';
import { reducer as discover } from './discover/reducer';
import { reducer as environment } from './environment/reducer';
import initData from './init-data/reducer';
import items from './items/reducer';
import language from './language/reducer';
import member from './member/reducer';
import memberStorage from './member-storage/reducer';
import multiCurrency from './multi-currency/reducer';
import page from './page/reducer';
import { reducer as personalisation } from './personalisation/reducer';
import pushNotifications from './push-notifications/push-notifications-slice';
import shippingRegion from './shipping-region/reducer';
import { reducer as ui } from './ui/reducer';
import views from './views/reducer';
import { connectRouter } from 'connected-react-router';
import { reducer as status } from './status/reducer';
import { discoverApi } from './services/discover-api';
import { independentSearchApi } from './services/independent-search-api';
import { feesApi } from './services/fees-api';
import { touchwebSearchApi } from './services/touchweb-search-api';
import { touchwebSyiApi } from './services/touchweb-syi-api';
import { wishListNudge } from 'tradera/apps/tradera/state/wish-list-nudge/reducer';
import type { History } from 'history';
import { bidHistoryApi } from 'tradera/components/bid-history/bid-history-api';
import { cartApi } from './services/cart-api';
import { messagingStatsApi } from './services/messaging-stats-api';
import { categoriesApi } from 'tradera/state/services/categories-api';
import { draftsApi } from 'tradera/apps/syi/state/drafts-api';
import { templatesApi } from 'tradera/apps/syi/state/templates-api';
import { shippingComplaintApi } from './services/shipping-complaint-api';
import { savedSearchesApi } from 'tradera/apps/my-tradera/saved-searches/saved-searches-api';
import { pickListApi } from 'tradera/apps/my-tradera/pick-list2/services/pick-list-api';
import { reducer as request } from './request/reducer';
import { reducer as random } from './random/reducer';
import { referralModalApi } from 'tradera/components/referral-modal/services/referral-modal-api';
import { wishListApi } from './services/wish-list-api';
import { wishListItemsEndingTodayApi } from './services/wish-list-items-ending-today-api';
import quickView from 'tradera/components/quick-view/quick-view-reducer';
import { ajaxItemApi } from 'tradera/components/quick-view/ajax-item-api';
import { firebaseApi } from 'tradera/components/messaging/firebase-api';
import { webApi } from 'tradera/state/services/webapi-api';
import { topListsApi } from 'tradera/apps/tradera/components/top-lists/top-lists-api';
import { sellerListApi } from 'tradera/apps/my-tradera/app/components/seller-list/seller-list-api';
import { bookedShipmentsApi } from 'tradera/apps/my-tradera/app/containers/booked-shipment-api';
import { loginApi } from 'tradera/apps/login/login-api';
import { loginSlice } from 'tradera/apps/login/state/reducer';
import { feedbackRemovalApi } from 'tradera/apps/tradera/resolution/feedback-removal/feedback-removal-api';
import { startPageThemeApi } from 'tradera/state/services/start-page-theme-api';

const rootReducer = (history: History) =>
    combineReducers({
        ads,
        bankId,
        auth,
        discover,
        environment,
        initData,
        items,
        language,
        member,
        memberStorage,
        multiCurrency,
        page,
        personalisation,
        pushNotifications,
        random,
        request,
        shippingRegion,
        ui,
        views,
        wishListNudge,
        router: connectRouter(history),
        status,
        [sellerListApi.reducerPath]: sellerListApi.reducer,
        [discoverApi.reducerPath]: discoverApi.reducer,
        [categoriesApi.reducerPath]: categoriesApi.reducer,
        [independentSearchApi.reducerPath]: independentSearchApi.reducer,
        [feesApi.reducerPath]: feesApi.reducer,
        [pickListApi.reducerPath]: pickListApi.reducer,
        [touchwebSearchApi.reducerPath]: touchwebSearchApi.reducer,
        [touchwebSyiApi.reducerPath]: touchwebSyiApi.reducer,
        [bidHistoryApi.reducerPath]: bidHistoryApi.reducer,
        [cartApi.reducerPath]: cartApi.reducer,
        [draftsApi.reducerPath]: draftsApi.reducer,
        [templatesApi.reducerPath]: templatesApi.reducer,
        [shippingComplaintApi.reducerPath]: shippingComplaintApi.reducer,
        [savedSearchesApi.reducerPath]: savedSearchesApi.reducer,
        [referralModalApi.reducerPath]: referralModalApi.reducer,
        [wishListApi.reducerPath]: wishListApi.reducer,
        [messagingStatsApi.reducerPath]: messagingStatsApi.reducer,
        [firebaseApi.reducerPath]: firebaseApi.reducer,
        [wishListItemsEndingTodayApi.reducerPath]:
            wishListItemsEndingTodayApi.reducer,
        quickView,
        [ajaxItemApi.reducerPath]: ajaxItemApi.reducer,
        [webApi.reducerPath]: webApi.reducer,
        [topListsApi.reducerPath]: topListsApi.reducer,
        [bookedShipmentsApi.reducerPath]: bookedShipmentsApi.reducer,
        login: loginSlice.reducer,
        [loginApi.reducerPath]: loginApi.reducer,
        [feedbackRemovalApi.reducerPath]: feedbackRemovalApi.reducer,
        [startPageThemeApi.reducerPath]: startPageThemeApi.reducer
    });

export default rootReducer;
